import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuardService } from "./common/services/auth/auth-guard.service";
import { HomeModule } from "./home/home.module";
import { HomeComponent } from "./home/home.component";

const routes: Routes = [
  {
    path: "",
    loadChildren: () =>
      import("./landing-page/landing-page.module").then(
        (m) => m.LandingPageModule
      ),
  },
  {
    path: "member/consent",
    loadChildren: () =>
      import("./consent/consent-screen/consent-screen.module").then(
        (m) => m.ConsentScreenModule
      ),
  },
  {
    path: "login/:id",
    loadChildren: () =>
      import("./start/login/login.module").then((m) => m.LoginModule),
  },
  {
    path: "register/:id",
    loadChildren: () =>
      import("./start/sign-up/sign-up.module").then((m) => m.SignUpModule),
  },
  {
    path: "set-password",
    loadChildren: () =>
      import("./start/set-password/set-password.module").then(
        (m) => m.SetPasswordModule
      ),
  },
  {
    path: "reset-password/:id",
    loadChildren: () =>
      import("./start/reset-forgot-password/reset-forgot-password.module").then(
        (m) => m.ResetForgotPasswordModule
      ),
  },
  {
    path: "reset-username/:id",
    loadChildren: () =>
      import("./start/reset-username/reset-username.module").then(
        (m) => m.ResetUsernameModule
      ),
  },
  {
    path: "forgot-password/:id",
    loadChildren: () =>
      import("./start/forgot-password/forgot-password.module").then(
        (m) => m.ForgotPasswordModule
      ),
  },
  {
    path: "forgot-username/:id",
    loadChildren: () =>
      import("./start/forgot-username/forgot-username.module").then(
        (m) => m.ForgotUsernameModule
      ),
  },
  {
    path: "otp-validation/:id",
    loadChildren: () =>
      import("./start/otp-validation/otp-validation.module").then(
        (m) => m.OtpValidationModule
      ),
  },
  {
    path: "otp-validation-password/:id",
    loadChildren: () =>
      import(
        "./start/otp-validation-password/otp-validation-password.module"
      ).then((m) => m.OtpValidationPasswordModule),
  },
  {
    path: "verfication-code",
    loadChildren: () =>
      import("./registration/verification-code/verification-code.module").then(
        (m) => m.VerificationCodeModule
      ),
  },
  {
    path: "reg-set-password",
    loadChildren: () =>
      import("./registration/reg-set-password/reg-set-password.module").then(
        (m) => m.RegSetPasswordModule
      ),
  },
  {
    path: "reg-set-pin",
    loadChildren: () =>
      import("./registration/reg-set-pin/reg-set-pin.module").then(
        (m) => m.RegSetPinModule
      ),
  },
  {
    path: "forgot-pin/:id",
    loadChildren: () =>
      import("./start/forgot-pin/forgot-pin.module").then(
        (m) => m.ForgotPinModule
      ),
  },
  {
    path: "otp-validation-pin/:id",
    loadChildren: () =>
      import("./start/otp-validation-pin/otp-validation-pin.module").then(
        (m) => m.OtpValidationPinModule
      ),
  },
  {
    path: "reset-pin/:id",
    loadChildren: () =>
      import("./start/reset-pin/reset-pin.module").then(
        (m) => m.ResetPinModule
      ),
  },
  {
    path: "home",
     component: HomeComponent,
    children: [
      {
        path: "organization",
        loadChildren: () =>
          import(
            "./home/application/organization/organization-registration-search/organization-registration-search.module"
          ).then((m) => m.OrganizationSearchModule),
      },
      {
        path: "branch",
        loadChildren: () =>
          import("./home/application/branch/branch.module").then(
            (m) => m.BranchModule
          ),
      },
      {
        path: "branch-new",
        loadChildren: () =>
          import("./home/application/branch/branch-new/branch-new.module").then(
            (m) => m.BranchNewModule
          ),
      },
      {
        path: "branch-detail",
        loadChildren: () =>
          import(
            "./home/application/branch/branch-detail/branch-detail.module"
          ).then((m) => m.BranchDetailModule),
      },
      {
        path: "product",
        loadChildren: () =>
          import("./home/application/product/product.module").then(
            (m) => m.ProductModule
          ),
      },
      {
        path: "product-view/:id",
        loadChildren: () =>
          import("./home/application/product/product-view/product-view.module").then(
            (m) => m.ProductViewModule
          ),
      },
      {
        path: "product-new",
        loadChildren: () =>
          import("./home/application/product/product-new/product-new.module").then(
            (m) => m.ProductNewModule
          ),
      },
      {
        path: "product-detail",
        loadChildren: () =>
          import(
            "./home/application/product/product-detail/product-detail.module"
          ).then((m) => m.ProductDetailModule),
      },
      {
        path: "user",
        loadChildren: () =>
          import(
            "./home/application/organization/user/user-search/user-search.module"
          ).then((m) => m.UserSearchModule),
      },
      {
        path: "user/detail",
        loadChildren: () =>
          import(
            "./home/application/organization/user/user-detail/user-detail.module"
          ).then((m) => m.UserDetailModule),
      },
      {
        path: "member",
        loadChildren: () =>
          import(
            "./home/application/member/member-search/member-search.module"
          ).then((m) => m.MemberSearchModule),
      },

      {
        path: "member-detail/:id",
        loadChildren: () =>
          import(
            "./home/application/member/member-detail/member-detail.module"
          ).then((m) => m.MemberDetailModule),
      },
      {
        path: "member-new/:id",
        loadChildren: () =>
          import("./home/application/member/member-new/member-new.module").then(
            (m) => m.MemberNewModule
          ),
      },
      {
        path: "pre-application",
        loadChildren: () =>
          import(
            "./home/application/pre-application/pre-application-search/pre-application-search.module"
          ).then((m) => m.PreApplicationSearchModule),
      },
      {
        path: "pre-application/detail/:id",
        loadChildren: () =>
          import(
            "./home/application/pre-application/pre-application-detail/pre-application-detail.module"
          ).then((m) => m.PreApplicationDetailModule),
      },
      {
        path: "onboard-application",
        loadChildren: () =>
          import(
            "./home/application/onboard-application/onboard-application-search/onboard-application-search.module"
          ).then((m) => m.OnboardApplicationSearchModule),
      },
      {
        path: "onboard-application/detail",
        loadChildren: () =>
          import(
            "./home/application/onboard-application/onboard-application-detail/onboard-application-detail.module"
          ).then((m) => m.OnboardApplicationDetailModule),
      },
      {
        path: "component-search",
        loadChildren: () =>
          import(
            "./components/components-search/components-search.module"
          ).then((m) => m.ComponentsSearchModule),
      },
      {
        path: "component-detail",
        loadChildren: () =>
          import(
            "./components/components-detail/components-detail.module"
          ).then((m) => m.ComponentsDetailModule),
      },
      {
        path: "customer",
        loadChildren: () =>
          import(
            "./home/application/customer/customer-search/customer-search.module"
          ).then((m) => m.CustomerSearchModule),
      },
      {
        path: "customer-detail",
        loadChildren: () =>
          import(
            "./home/application/customer/customer-detail/customer-detail.module"
          ).then((m) => m.CustomerDetailModule),
      },
      {
        path: "organisation",
        loadChildren: () =>
          import(
            "./home/customer-application/organisation/organisation.module"
          ).then((m) => m.OrganisationModule),
      },
      {
        path: "my-profile",
        loadChildren: () =>
          import(
            "./home/customer-application/my-profile/my-profile-view/my-profile-view.module"
          ).then((m) => m.MyProfileViewModule),
      },
      {
        path: "my-profile-new",
        loadChildren: () =>
          import(
            "./home/customer-application/my-profile/my-profile-edit/my-profile-edit.module"
          ).then((m) => m.MyProfileEditModule),
      },
      {
        path: "insurance",
        loadChildren: () =>
          import(
            "./home/member/insurance/insurance-landing/insurance-landing.module"
          ).then((m) => m.InsuranceLandingModule),
      },
      {
        path: "insurance/list",
        loadChildren: () =>
          import(
            "./home/member/insurance/insurance-search/insurance-search.module"
          ).then((m) => m.InsuranceSearchModule),
      },
      {
        path: "insurance/detail",
        loadChildren: () =>
          import(
            "./home/member/insurance/insurance-detail/insurance-detail.module"
          ).then((m) => m.InsuranceDetailModule),
      },
      {
        path: "cooperative",
        loadChildren: () =>
          import(
            "./home/member/cooperative/cooperative-search/cooperative-search.module"
          ).then((m) => m.CooperativeSearchModule),
      },
      {
        path: "cooperative/detail",
        loadChildren: () =>
          import(
            "./home/member/cooperative/cooperative-detail/cooperative-detail.module"
          ).then((m) => m.CooperativeDetailModule),
      },
      {
        path: "my-policy",
        loadChildren: () =>
          import("./home/member/my-policy/my-policy.module").then(
            (m) => m.MyPolicyModule
          ),
      },
      {
        path: "policy/:orgCode/:productId/:productCode",
        loadChildren: () =>
          import("./home/policy-viewer/policy-viewer.module").then(
            (m) => m.PolicyViewerModule
          ),
      },
      {
        path: "policy-search",
        loadChildren: () =>
          import("./home/application/member-policy/member-policy.module").then(
            (m) => m.MemberPolicyModule
          ),
      },
      {
        path: "member-policy/detail",
        loadChildren: () =>
          import("./home/application/member-policy/member-policy-detail/member-policy-detail.module").then(
            (m) => m.MemberPolicyDetailModule
          ),
      },
      {
        path: "payout-search",
        loadChildren: () =>
          import("./home/application/member-payout/member-payout.module").then(
            (m) => m.MemberPayoutModule
          ),
      },
      {
        path: "onboard",
        loadChildren: () =>
          import(
            "./home/member/onboard-application-member/onboard-application-member.module"
          ).then((m) => m.OnboardApplicationMemberModule),
      },
      {
        path: "profile",
        loadChildren: () =>
          import("./home/member/my-profile/my-profile.module").then(
            (m) => m.MyProfileModule
          ),
      },
      {
        path: "insurance-providers-onboard",
        loadChildren: () =>
          import(
            "./home/member/onboard-application-member/insurance-providers-onboard/insurance-providers-onboard.module"
          ).then((m) => m.InsuranceProvidersOnboardModule),
      },
      {
        path: "insurance-policy-onboard",
        loadChildren: () =>
          import(
            "./home/member/onboard-application-member/insurance-policies-onboard/insurance-policies-onboard.module"
          ).then((m) => m.InsurancePoliciesOnboardModule),
      },
      {
        path: "member-consent",
        loadChildren: () =>
          import("./home/member/member-consent/member-consent.module").then(
            (m) => m.MemberConsentModule
          ),
      },
      {
        path: "upload-error",
        loadChildren: () =>
          import("./home/application/upload-error/upload-error.module").then(
            (m) => m.UploadErrorModule
          ),
      },
      {
        path: "location-verification",
        loadChildren: () =>
          import(
            "./home/location/location-verification/location-verification.module"
          ).then((m) => m.LocationVerificationModule),
      },
      {
        path: "wrms-event-search",
        loadChildren: () =>
          import("./home/wrms/wrms-event-search/wrms-event-search.module").then(
            (m) => m.WrmsEventSearchModule
          ),
      },
      {
        path: "upload-policy",
        loadChildren: () =>
          import("./home/application/upload-policy/upload-policy.module").then(
            (m) => m.UploadPolicyModule
          ),
      },
      {
        path: "loss-percentage",
        loadChildren: () =>
          import(
            "./home/application/loss-percentage/loss-percentage.module"
          ).then((m) => m.LossPercentageModule),
      },
      {
        path: "upload-policy-errorlog/:id",
        loadChildren: () =>
          import("./home/application/upload-policy/upload-policy-errorlog/upload-policy-errorlog.module").then(
            (m) => m.UploadPolicyErrorlogModule
          ),
      },
      {
        path: "upload-payout",
        loadChildren: () =>
          import("./home/application/upload-payout/upload-payout.module").then(
            (m) => m.UploadPayoutModule
          ),
      },
      {
        path: "upload-payout-errorlog/:id",
        loadChildren: () =>
          import("./home/application/upload-payout/upload-payout-errorlog/upload-payout-errorlog.module").then(
            (m) => m.UploadPayoutErrorlogModule
          ),
      },
      {
        path: "upload-loss-percentage",
        loadChildren: () =>
          import("./home/application/upload-loss-percentage/upload-loss-percentage.module").then(
            (m) => m.UploadLossPercentageModule
          ),
      },
      {
        path: "upload-loss-percentage-errorlog/:id",
        loadChildren: () =>
          import("./home/application/upload-loss-percentage/upload-loss-percentage-errorlog/upload-loss-percentage-errorlog.module").then(
            (m) => m.UploadLossPercentageErrorlogModule
          ),
      },
      {
        path: "download-loss-info",
        loadChildren: () =>
          import("./home/application/download-loss-info/download-loss-info.module").then(
            (m) => m.DownloadLossInfoModule
          ),
      },
      {
        path: "download-active-members",
        loadChildren: () =>
          import("./home/application/download-active-members/download-active-members.module").then(
            (m) => m.DownloadActiveMembersModule
          ),
      },
      {
        path: "member-registration-report",
        loadChildren: () =>
          import("./home/application/reports/member-registration-report/member-registration-report.module").then(
            (m) => m.MemberRegistrationReportModule
          ),
      },
      {
        path: "member-loss-report",
        loadChildren: () => import("./home/application/reports/member-loss-computation-detail/member-loss-computation-detail.module").then((m) => m.MemberLossComputationDetailModule)
      }
      // {
      //   path: "preview-application",
      //   loadChildren: () =>
      //     import("./home/application/onboard-application/onboard-application-detail/preview-application/preview-application.module").then(
      //       (m) => m.PreviewApplicationModule
      //     ),
      // },
    ],
  },
  { path: "**", redirectTo: "/" },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      relativeLinkResolution: "legacy",
      scrollPositionRestoration: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
